export default "__VITE_ASSET__BnVraKvS__"